import { Components, Theme } from "@mui/material";

export const InputStyle = (
  theme: Theme
): Pick<Components, "MuiTextField" | "MuiInputLabel"> => {
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          ".MuiOutlinedInput-root": {
            backgroundColor: "#222222",
            fontSize: "14px",
          },

          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "#363636",
            top: 0,
          },

          ".MuiOutlinedInput-input": {
            color: "#808080",
          },

          legend: {
            display: "none",
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#FFFFFF",
          transform: "translate(0, -26px)",
          fontSize: "14px",
        },
      },
    },
  };
};
